import 'regenerator-runtime';

import App from './App.vue';
// import PortalVue from 'portal-vue';
import Vue from 'vue';
// import VueCustomElement from 'vue-custom-element';
// import VueResource from 'vue-resource';
import store from './store/';

//var VueScrollTo = require("vue-scrollto");
//Vue.use(VueScrollTo);
// Vue.use(VueResource);
// Vue.use(VueCustomElement);
// Vue.use(PortalVue);

Vue.config.productionTip = false;
App.store = store;

var AdaBundlePack = {
  Init(payload) {
    const portal = document.createElement('div');
    portal.id = 'adabundle-widget';
    document.getElementsByTagName('body')[0].appendChild(portal);

    new Vue({
      el: '#adabundle-widget',
      store,
      render(h) {
        return h(App, {
          props: payload,
        });
      },
    });
  },
};

const AdaBundle = AdaBundlePack || {};

const embedId = document.currentScript.getAttribute('embed-id');

window.adabundleWidget = window.adabundleWidget || {};
window.adabundleWidget.installed = window.adabundleWidget.installed || false;

var embed = window.adabundleWidget;

if (!embed.installed) {
  AdaBundle.Init({
    wid: embedId,
    debug: false,
  });

  embed.installed = true;
}

export default AdaBundle;